import { HorizontalContainer } from './Containers';
import { Text } from './Texts';
import StatusDot from './StatusDot';
import designSystemStyles from '@shared/styles/designSystemStyles';
import styles from '@shared/styles/components/StatusBadge.module.css';

interface StatusBadgeProps {
    label: string;
    color: string;
    className?: string;
}

const StatusBadge: React.FC<StatusBadgeProps> = ({ label, color, className }) => (
    <HorizontalContainer
        className={['DSStatusBadge', className].filter(Boolean).join(' ')}
        gap={designSystemStyles.gapXxxSm}
        alignment="center"
        width="auto"
    >
        <StatusDot color={color} />
        <Text
            className={styles.label}
            text={label}
            color={color}
        />
    </HorizontalContainer>
);

export default StatusBadge;
